import { useEffect, useRef, useState, useMemo } from "react";

// import nextArr from '../../assets/ALeft.png'
// import prevArr from '../../assets/ARight.png'

// import dummy from '../../assets/samples/body.png'
// import dummy1 from '../../assets/samples/BODY1.png'
// import dummy2 from '../../assets/samples/body2.png'

import new_body from '../../assets/Body/new_suit_body.jpg'

import pant_body from '../../assets/Body/pant_body.png'

import formal_body from '../../assets/Body/pant_shirt_formal_body.jpg'


import kurta_body from '../../assets/Body/kurta_body.png'
import pajama_body from '../../assets/Body/pajama_body.png'

import aim from '../../assets/samples/anima.gif'
// import { dummyImg } from '../../Data'

import Tooltip from '@mui/material/Tooltip';

import Zoom from '@mui/material/Zoom';


import M from '../../assets/icon/magnifying.svg'
import War from '../../assets/icon/w.svg'
// import warning1 from '../../assets/icon/warning.svg'

import '../fabric.css'


import default_shirt1 from '../../assets/samples/shirt/SHIRT.webp'
import default_shirt_formal from '../../assets/samples/shirt_1.png'

import pant_body_new from '../../assets/Body/body_for_pant.jpg'

import def_pant from '../../assets/Body/F-NP.webp'

import default_pant_formal from '../../assets/Body/pant.png'
import sadri_def from '../../assets/Body/sadri_def.png'

import kurta_hand_n from '../../assets/Body/kurta_hand_n.png'
import kurta_hand_s from '../../assets/Body/kurta_hand_s.png'
import kurta_hand_k from '../../assets/Body/kurta_hand_k.png'


import kurta_hand_c from '../../assets/Body/kurta_hand_c.png'

import model_body from '../../assets/renders/MODEL_1/BODY.png'
import hand_cuff from '../../assets/renders/MODEL_1/HAND_FOR_CUFF_SLEEVE.png'
import hand_non_cuff from '../../assets/renders/MODEL_1/HAND_FOR_NON_CUFF_SLEEVE.png'

import { checkCategory } from "../../Functions";
import BodySelection from "../../common/bodySelection";

const kurtaImages = {
  "BASE": require("../../assets/renders/KURTA/1ST/R.webp"), // Placeholder: Replace with BASE.webp when available
  "BE": require("../../assets/renders/KURTA/1ST/BE.webp"),
  "BKC": require("../../assets/renders/KURTA/1ST/BKC.webp"),
  "BKN": require("../../assets/renders/KURTA/1ST/BKN.webp"),
  "BPL": require("../../assets/renders/KURTA/1ST/BPL.webp"),
  "BPR": require("../../assets/renders/KURTA/1ST/BPR.webp"),
  "CB": require("../../assets/renders/KURTA/1ST/CB.webp"),
  "CC": require("../../assets/renders/KURTA/1ST/CC.webp"),
  "CE": require("../../assets/renders/KURTA/1ST/CE.webp"),
  "CM": require("../../assets/renders/KURTA/1ST/CM.webp"),
  "CN": require("../../assets/renders/KURTA/1ST/CN.webp"),
  "CR": require("../../assets/renders/KURTA/1ST/CR.webp"),
  "CS": require("../../assets/renders/KURTA/1ST/CS.webp"),
  "CT": require("../../assets/renders/KURTA/1ST/CT.webp"),
  "D": require("../../assets/renders/KURTA/1ST/D.webp"),
  "FLN": require("../../assets/renders/KURTA/1ST/FLN.webp"),
  "FLR": require("../../assets/renders/KURTA/1ST/FLR.webp"),
  "FLS": require("../../assets/renders/KURTA/1ST/FLS.webp"),
  "FRN": require("../../assets/renders/KURTA/1ST/FRN.webp"),
  "FRR": require("../../assets/renders/KURTA/1ST/FRR.webp"),
  "FRS": require("../../assets/renders/KURTA/1ST/FRS.webp"),
  "LN": require("../../assets/renders/KURTA/1ST/LN.webp"),
  "LR": require("../../assets/renders/KURTA/1ST/LR.webp"),
  "LS": require("../../assets/renders/KURTA/1ST/LS.webp"),
  "NH0": require("../../assets/renders/KURTA/1ST/NH0.webp"),
  "NS0": require("../../assets/renders/KURTA/1ST/NS0.webp"),
  "NS3": require("../../assets/renders/KURTA/1ST/NS3.webp"),
  "NS4": require("../../assets/renders/KURTA/1ST/NS4.webp"),
  "QH0": require("../../assets/renders/KURTA/1ST/QH0.webp"),
  "QS0": require("../../assets/renders/KURTA/1ST/QS0.webp"),
  "QS3": require("../../assets/renders/KURTA/1ST/QS3.webp"),
  "QS4": require("../../assets/renders/KURTA/1ST/QS4.webp"),
  "R-COAT": require("../../assets/renders/KURTA/1ST/R-COAT.webp"),
  "R-SADRI": require("../../assets/renders/KURTA/1ST/R-SADRI.webp"),
  "R": require("../../assets/renders/KURTA/1ST/R.webp"),
  "RN": require("../../assets/renders/KURTA/1ST/RN.webp"),
  "RR": require("../../assets/renders/KURTA/1ST/RR.webp"),
  "RS": require("../../assets/renders/KURTA/1ST/RS.webp"),
  "S-COAT": require("../../assets/renders/KURTA/1ST/S-COAT.webp"),
  "S-SADRI": require("../../assets/renders/KURTA/1ST/S-SADRI.webp"),
  "S": require("../../assets/renders/KURTA/1ST/S.webp"),
  "SC-SADRI": require("../../assets/renders/KURTA/1ST/SC-SADRI.webp"),
  "SC": require("../../assets/renders/KURTA/1ST/SC.webp"),
  "SE": require("../../assets/renders/KURTA/1ST/SE.webp"),
  "SN-SADRI": require("../../assets/renders/KURTA/1ST/SN-SADRI.webp"),
  "SN": require("../../assets/renders/KURTA/1ST/SN.webp"),
  "T": require("../../assets/renders/KURTA/1ST/T.webp"),
};

const secondKurtaImages = {
    "BASE": require("../../assets/renders/KURTA/2ND/BASE1.png"),
    "SC": require("../../assets/renders/KURTA/2ND/SC.png"),
    "SN": require("../../assets/renders/KURTA/2ND/SN.png"),
    "BC2": require("../../assets/renders/KURTA/2ND/BC2.png"),
    "BC4": require("../../assets/renders/KURTA/2ND/BC4.png"),
    "BKC": require("../../assets/renders/KURTA/2ND/BKC.png"),
    "BKN": require("../../assets/renders/KURTA/2ND/BKN.png"),
    "BE": require("../../assets/renders/KURTA/2ND/BE.png"),
    "SE": require("../../assets/renders/KURTA/2ND/SE.png"),
    "BPL": require("../../assets/renders/KURTA/2ND/BPL.png"),
    "BPR": require("../../assets/renders/KURTA/2ND/BPR.png"),
    
    // Collars
    "CB": require("../../assets/renders/KURTA/2ND/CB.png"),
    "CE": require("../../assets/renders/KURTA/2ND/CE.png"),
    "CR": require("../../assets/renders/KURTA/2ND/CR.png"),
    "CS": require("../../assets/renders/KURTA/2ND/CS.png"),
    "CT": require("../../assets/renders/KURTA/2ND/CT.png"),
    
    // Plackets
    "NS3": require("../../assets/renders/KURTA/2ND/NS3.png"),
    "NS31": require("../../assets/renders/KURTA/2ND/NS31.png"),
    "NS41": require("../../assets/renders/KURTA/2ND/NS41.png"),
    "QS3": require("../../assets/renders/KURTA/2ND/QS3.png"),
    "QS31": require("../../assets/renders/KURTA/2ND/QS31.png"),
    "QS41": require("../../assets/renders/KURTA/2ND/QS41.png"),

    // Pockets
    "LN": require("../../assets/renders/KURTA/2ND/LN.png"),
    "LR": require("../../assets/renders/KURTA/2ND/LR.png"),
    "LS": require("../../assets/renders/KURTA/2ND/LS.png"),
    "RN": require("../../assets/renders/KURTA/2ND/RN.png"),
    "RR": require("../../assets/renders/KURTA/2ND/RR.png"),
    "RS": require("../../assets/renders/KURTA/2ND/RS.png"),
    
    // Flaps
    "FLN": require("../../assets/renders/KURTA/2ND/FLN.png"),
    "FLR": require("../../assets/renders/KURTA/2ND/FLR.png"),
    "FLS": require("../../assets/renders/KURTA/2ND/FLS.png"),
    "FRN": require("../../assets/renders/KURTA/2ND/FRN.png"),
    "FRR": require("../../assets/renders/KURTA/2ND/FRR.png"),
    "FRS": require("../../assets/renders/KURTA/2ND/FRS.png"),

    // Cuff Variants
    "US1": require("../../assets/renders/KURTA/2ND/US1.png"),
    "US2": require("../../assets/renders/KURTA/2ND/US2.png"),
    "UR1": require("../../assets/renders/KURTA/2ND/UR1.png"),
    "UR2": require("../../assets/renders/KURTA/2ND/UR2.png"),
    "UN1": require("../../assets/renders/KURTA/2ND/UN1.png"),
    "UN2": require("../../assets/renders/KURTA/2ND/UN2.png"),
};

 
function ViewImages({category, sel, single, loading, setLoading, imgState, setImgState, type, isMobile, setState1 = () => {}, jodh, initial, currBody, setCurrBody, getStyleImg}) {
    // const [imgState, setImgState] = useState(0)
    const [Single, setSingle] = useState()
    const [state, setState] = useState(1)

    const [magnify, setMagnify] = useState(false)
    const [[x, y], setXY] = useState([0, 0])

    const [def_body, setDefBody] = useState(
        (category === "suit" || category === "blazer") ? new_body 
        : category === "formal" ? currBody.body 
        : category === "shirt" ? currBody.body 
        : category === "pant" ? pant_body_new 
        : (category === "kurta" || category === "sadri") ? kurta_body
        : new_body
        );
    
    const [def_shirt, set_def_shirt] = useState(
        (category === "suit" || category === "blazer") ? default_shirt1
        : category === "formal" ? default_pant_formal
        : category === "pant" ?  default_pant_formal
        : category === "shirt" ? def_pant
        : category === "sadri" ? sadri_def
        : default_shirt1
    )

    const [hands, setHands] = useState(
        ((sel?.types && sel.types.includes("Coat") && imgState < 0) || (category === "sadri" && imgState === 0)) ? kurta_hand_c
        : sel?.types && sel.types.includes("Sadri") && imgState < 0 && sel?.style?.Kurta?.F[8] === "SC" ? kurta_hand_s
        : kurta_hand_n
    )

    const secondLayers = useMemo(() => {
        if (category !== "kurta" || !sel) return [];
        const sec = sel.second_images || {};
        const layers = [];
        
        // Helper
        const add = (z, src, key) => {
            if (src) layers.push({ z, src, key });
        };

        // Stack Logic based on Backup:
        // BASE (3) -> SLEVE (4) -> CUFF/BODY (5) -> POCKETS(6) -> FLAPS(7) -> BPR/BPL(8) -> COLLAR(9) -> BKN/BKC(10) -> EPAULETTE(11) -> BE(12) -> BC2/BC4 (13)

        // 1. BASE Layer (Always present)
        add(3, secondKurtaImages["BASE"], "BASE");

        try {
            if (sel.style && sel.style.Kurta && sel.style.Kurta.F) {
                const F = sel.style.Kurta.F;
                const sleeve = F[8]; // SN, SC
                
                if (sleeve === "SC") {
                    // SC Logic:
                    // Add SLEVE (SC)
                    add(4, secondKurtaImages["SC"], "SLEVE_SC");
                    
                    const cuffStyle = F[9]; // US1, UR1, UN1, US2...
                    
                    // Determine Variant Key
                    let variantKey = cuffStyle; // Default to US1
                    let src = sec[variantKey];

                    if (!src) {
                        // Try mapped keys (SC_1..SC_6)
                        const map = { "US1": "SC_1", "UR1": "SC_2", "UN1": "SC_3", "US2": "SC_4", "UR2": "SC_5", "UN2": "SC_6" };
                        const mappedKey = map[cuffStyle];
                        if (mappedKey && sec[mappedKey]) {
                            variantKey = mappedKey;
                            src = sec[mappedKey];
                        }
                    }

                    // Fallback for testing (if US1.png exists locally)
                    if (!src && secondKurtaImages[cuffStyle]) {
                         src = secondKurtaImages[cuffStyle];
                    }

                    if (src) {
                        add(5, src, variantKey);
                    }

                    // Add BC2/BC4 based on cuff style ending
                    const suffix = cuffStyle && cuffStyle.length >= 3 ? cuffStyle[2] : "1";
                    if (suffix === "1") {
                        add(13, secondKurtaImages["BC2"], "BC2");
                    } else {
                        add(13, secondKurtaImages["BC4"], "BC4");
                    }

                } else {
                    // SN Logic
                    // Add SN_DEFAULT
                    let variantKey = "SN_DEFAULT";
                    let src = sec[variantKey];
                    
                    if (!src && secondKurtaImages["SN"]) {
                        src = secondKurtaImages["SN"];
                    }
                    
                    if (src) {
                        add(5, src, variantKey);
                    }
                }

                // Pockets Logic
                // F[2] = 00 (None), 01 (1 Pkt), 11 (2 Pkt)
                // F[3] = R (Round), N (Notch), S (Square)
                if (F[2] === "01") {
                    // Right Pocket Only
                    const key = "R" + F[3]; // RN, RR, RS
                    add(6, secondKurtaImages[key], key);
                } else if (F[2] === "11") {
                    // Both
                    const keyL = "L" + F[3]; // LN, LR, LS
                    const keyR = "R" + F[3]; // RN, RR, RS
                    add(6, secondKurtaImages[keyL], keyL);
                    add(6, secondKurtaImages[keyR], keyR);
                }

                // Flaps Logic
                // F[4] = 0 (No), 1 (Yes)
                // F[5] = R (Round), N (Notch), S (Square)
                if (F[4] === "1" && F[2] !== "00") {
                   if (F[2] === "01") {
                       // Right Flap
                       const key = "FR" + F[5]; // FRN, FRR, FRS
                       add(7, secondKurtaImages[key], key);
                       add(9, secondKurtaImages["BPR"], "BPR");
                   } else if (F[2] === "11") {
                       // Both
                       const keyL = "FL" + F[5]; // FLN, FLR, FLS
                       const keyR = "FR" + F[5]; // FRN, FRR, FRS
                       add(7, secondKurtaImages[keyL], keyL);
                       add(7, secondKurtaImages[keyR], keyR);
                       add(9, secondKurtaImages["BPL"], "BPL");
                       add(9, secondKurtaImages["BPR"], "BPR");
                   }
                }

                // Epaulette Logic
                // F[6] = SE (Yes)
                // Backup: SE (L[6]) -> BE (Pushed) -> Collar (Pushed)
                // So SE < BE < Collar
                if (F[6] === "SE") {
                    add(8, secondKurtaImages["SE"], "SE");
                    add(10, secondKurtaImages["BE"], "BE");
                }

                // Collar & Neck Logic
                // F[7] = Collar Type (CR, CB, CT, CS, CE, CA, CM, CC)
                // F[1] = Neck Placket (NS, QS)

                const isShirtCollar = ["CR", "CB", "CT", "CS", "CE"].includes(F[7]);

                if (isShirtCollar) {
                    // Shirt Collar
                    add(11, secondKurtaImages[F[7]], F[7]);
                    
                    // Neck Placket Logic: Append "3"
                    let placketKey = F[1] + "3"; 
                    // Fallback checks
                    if (!secondKurtaImages[placketKey]) {
                        // Try NS31/QS31 if NS3/QS3 missing
                        if (secondKurtaImages[placketKey + "1"]) placketKey += "1";
                    }
                    
                    add(4, secondKurtaImages[placketKey], placketKey);
                    add(12, secondKurtaImages["BKN"], "BKN");
                    
                } else {
                    // Chinese/Mandarin
                    let placketKey = F[1] + "4"; // NS4, QS4.
                    
                    // Check if placket key exists directly (e.g. NS4) or with suffix (NS41)
                    if (!secondKurtaImages[placketKey]) {
                        if (secondKurtaImages[placketKey + "1"]) {
                             placketKey += "1";
                        }
                    }
                    
                    add(4, secondKurtaImages[placketKey], placketKey);
                    add(12, secondKurtaImages["BKC"], "BKC");
                }

            }
        } catch (e) {
            console.warn("2nd image sleeve error:", e);
        }

        // 2. Other Static Layers (Map keys to Z-index) - Clean up duplicates if needed
        Object.keys(sec).forEach(key => {
            if (key.startsWith("SC_") || key === "SN_DEFAULT" || key === "US1" || key === "UR1" || key === "UN1" || key === "US2" || key === "UR2" || key === "UN2") return; 
            // Skip keys already handled?
        });

        return layers.sort((a, b) => a.z - b.z);
    }, [category, sel]);

    const hasSecondImage = category === "kurta" && secondLayers.length > 0;

    const kurtaLayers = useMemo(() => {
        if (category !== "kurta" || !sel || !sel.style || !sel.style.Kurta || !sel.style.Kurta.F) return [];
        const layers = [];
        const F = sel.style.Kurta.F;
        const styles = sel.styles || {};
        
        // Attributes mapping
        const bottomCut = F[0]; // R, S, D, T, P, Q, K, L
        const neckPlacket = F[1]; // NS, QS
        const pocketCount = F[2]; // 00, 01, 11
        const pocketType = F[3]; // R, N, S
        const flap = F[4]; // 0, 1
        const flapType = F[5]; // R, N, S
        // const epaulette = F[6]; // 0, SE
        const collar = F[7]; // CA, CM, CC, CR, CB, CS, CT, CE
        const sleeve = F[8]; // SN, SC
        const length = F[10]; // L (Normal), S (Short)
        
        const pathaniCollars = ["CT", "CE", "CS", "CR", "CB"];

        // Helper to safely add layer
        const add = (z, src, key) => {
            if (src) {
                if (Array.isArray(src)) {
                    src.forEach((s, i) => layers.push({ z, src: s, key: `${key}_${i}` }));
                } else {
                    layers.push({ z, src, key });
                }
            }
        };

        // 01: MODEL_BASE (BODY)
        const bodySrc = sel?.modelSrc || model_body;
        add(1, bodySrc, "MODEL_BASE");

        // 02: PAJAMA (From sel.fabric)
        if (sel?.types?.includes("Pajama") && sel?.fabric?.["Pajama"]?.src) {
            add(2, sel.fabric["Pajama"].src, "PAJAMA");
        }

        // 03: KURTA_BASE (BODY)
        // Determine Body Type based on Length, Pathani status, and Bottom Cut
        
        // FIX: Remove placket dependency for isShort to ensure Normal Length is respected
        const isShort = ["S", "P_S", "QS_S"].includes(length);
        
        // FIX: Enable Pathani mode if a Pathani collar is selected
        const isPathani = ["P_S", "QS_S"].includes(length) || neckPlacket === "QS_SP" || pathaniCollars.includes(collar); 
        
        const isRound = bottomCut === "R" || bottomCut === "N" || !bottomCut; // Default to Round
        const isStraight = bottomCut === "S";

        let bodyKey = null;

        if (isShort) {
             // Short: P(Round)/Q(Straight) for Pathani, K(Round)/L(Straight) for Kurta
            if (isPathani) {
                if (isRound) bodyKey = "P";
                else if (isStraight) bodyKey = "Q";
            }
            // Fallback/Default to Kurta Short if not Pathani or key missing
            if (!bodyKey || !styles[bodyKey]) {
                if (isRound) bodyKey = "K";
                else if (isStraight) bodyKey = "L";
            }
        } else {
            // Long: D(Round)/T(Straight) for Pathani, R(Round)/S(Straight) for Kurta
            if (isPathani) {
                if (isRound) bodyKey = "D";
                else if (isStraight) bodyKey = "T";
            }
            if (!bodyKey || !styles[bodyKey]) {
                if (isRound) bodyKey = "R";
                else if (isStraight) bodyKey = "S";
            }
        }

        if (bodyKey && styles[bodyKey]) {
            add(3, styles[bodyKey], bodyKey);
        } else if (!sel?.modelSrc && kurtaImages["BASE"]) {
             // Fallback to BASE (R.webp) if no body found
            add(3, kurtaImages["BASE"], "K_FALLBACK");
        }

        // 04: PLACKET (NS3/4, QS3/4) + BUTTONS (BKN/BKC)
        // Strict filtering: Pathani -> Suffix 3, Kurta -> Suffix 4
        // Pathani (Red): NS3, QS3, BKN
        // Kurta (Black): NS4, QS4, BKC
        const neckSuffix = isPathani ? "3" : "4";
        let neckKey = null;
        let btnKey = null;
        
        if (neckPlacket.startsWith("NS")) { // NS, NS_SK
            neckKey = "NS" + neckSuffix;
            btnKey = isPathani ? "BKN" : "BKC"; 
        } else if (neckPlacket.startsWith("QS")) { // QS, QS_SP
            neckKey = "QS" + neckSuffix;
            // Square Placket usually has no visible buttons in this set, or they are integrated
        }

        if (neckKey && styles[neckKey]) {
            add(4, styles[neckKey], neckKey);
            if (btnKey && styles[btnKey]) add(4, styles[btnKey], btnKey);
        }

        // 05: COLLAR (C*)
        // Pathani (Red): CT, CE, CS, CR, CB
        // Kurta (Black): CN, CM, CC
        // FIX: Render ONLY the selected collar
        if (collar && styles[collar]) {
             add(5, styles[collar], collar);
        }
        // Collar Buttons (CB_HOL, CB_BTN)
        if (styles["CB_HOL"]) add(5, styles["CB_HOL"], "CB_HOL");
        if (styles["CB_BTN"]) add(5, styles["CB_BTN"], "CB_BTN");


        // 06: POCKET (LN, LR, LS, RN, RR, RS)
        // Pathani (Red): LN, LR, LS
        // Kurta (Black): RN, RR, RS
        if (pocketCount !== "00") {
             const pType = pocketType || "R"; // Default to Round if missing
             const suffix = pType === "N" ? "N" : pType === "S" ? "S" : "R";
             
             // Determine Prefix based on Pathani/Kurta
             // FIX: Always use "R" (Right) for single pocket as per user request
             const prefix = "R";
             const key = prefix + suffix; // e.g., LN or RN
             
             if (styles[key]) add(6, styles[key], key);
        }

        // 07: FLAP (FLN... FRS) + BUTTONS (BPL, BPR)
        // Pathani (Red): FLN, FLR, FLS, BPL, BHPL1
        // Kurta (Black): FRN, FRR, FRS, BPR, BHPR1
        if (flap === "1" && pocketCount !== "00") {
             const fType = flapType || "R"; 
             const suffix = fType === "N" ? "N" : fType === "S" ? "S" : "R";
             
             // FIX: Always use "FR" (Right Flap) to match the Right Pocket
             const prefix = "FR";
             const key = prefix + suffix; 
             
             if (styles[key]) {
                 add(7, styles[key], key);
                 
                 // Buttons
                 // FIX: Always use BPR/BHPR1 (Right Buttons) to match Right Pocket
                 if (styles["BPR"]) add(7, styles["BPR"], "BPR");
                 if (styles["BHPR1"]) add(7, styles["BHPR1"], "BHPR1");
             }
        }

        // 08: SLEEVE (SN, SC)
        // Pathani (Red): SN (Normal/Cuff logic handled by selection, but strict style mapping)
        // Kurta (Black): SC
        // FIX: Respect user's sleeve selection (sleeve = F[8])
        if (sleeve === "SC" && styles["SC"]) {
            add(8, styles["SC"], "SC");
        } else if (sleeve === "SN" && styles["SN"]) {
            add(8, styles["SN"], "SN");
        } else {
             // Fallback if specific selection missing or generic logic needed
             if (isPathani && styles["SN"]) add(8, styles["SN"], "SN");
             else if (styles["SC"]) add(8, styles["SC"], "SC");
        }

        // 09: EPAULETTE (SE) + BUTTONS (BE, BHE)
        // Pathani (Red): SE
        // Kurta (Black): No Epaulette shown
        // FIX: Show Epaulette if user selected "SE", regardless of Pathani mode
        if (F[6] === "SE" && styles["SE"]) {
            add(9, styles["SE"], "SE");
            if (styles["BE"]) add(9, styles["BE"], "BE");
            if (styles["BHE"]) add(9, styles["BHE"], "BHE");
        }
        
        // 10: SADRI/COAT (From sel.fabric)
        if (sel?.types?.includes("Sadri") && sel?.fabric?.["Sadri"]?.src) {
             add(10, sel.fabric["Sadri"].src, "SADRI");
        } else if (sel?.types?.includes("Coat") && sel?.fabric?.["Coat"]?.src) {
             add(10, sel.fabric["Coat"].src, "COAT");
        } else if (sel?.types?.includes("Vest") && sel?.fabric?.["Vest"]?.src) {
             add(10, sel.fabric["Vest"].src, "VEST");
        }



        // 11: MODEL_HANDS (HAND) - TOP LAYER
        let handSrc = null;
        
        // Determine active sleeve type
        let activeSleeve = sleeve;
        if (!activeSleeve) {
             activeSleeve = isPathani ? "SN" : "SC";
        }

        // Fix: Depend on Sleeve Type, not Pathani mode
        // SC = Cuff -> hand_cuff
        // SN = Normal -> hand_non_cuff
        
        if (activeSleeve === "SC") {
             handSrc = sel?.handsCuffSrc || sel?.handsSrc || (!sel?.modelSrc ? hand_cuff : null);
        } else {
             // SN or default
             handSrc = sel?.handsNonCuffSrc || sel?.handsSrc || (!sel?.modelSrc ? hand_non_cuff : null);
        }

        if (handSrc) add(11, handSrc, "MODEL_HANDS");

        return layers.sort((a, b) => a.z - b.z);
    }, [category, sel]);

    useEffect(()=>{
        if(category && (category === "formal" || category === "shirt")){
            setDefBody( currBody.body )
        }
    }, [currBody])
    
    /// to change hand
    useEffect(()=>{
        if(imgState<0){
            if( sel?.types && sel.types.includes("Sadri") && sel?.style?.Kurta?.F[8] === "SC" ){
                setHands( kurta_hand_s )
            } else if(sel?.types && sel.types.includes("Sadri") ) {
                setHands( kurta_hand_n )
            }
        }
    }, [sel])

    

    const magnifyStyle = (X, Y) => ({
        transform:`scale(3)`,
        left: `${X}%`,
        top: `${Y}%`
      });

    useEffect(()=>{ 
        // console.log("type received ", type)

        

        if(type === 1){
            // const p = ["Coat", "Vest", "Pant", "Shirt"]
            const p = sel.types
            let data = []
            p.forEach((typS)=>{
                
                data = [...data, ...sel["fabric"][typS]["single"]]
            })
            setSingle(data)
            if (typeof setState1 === 'function') setState1(data.length + 1)
        }else{
            if (hasSecondImage) {
                if (typeof setState1 === 'function') setState1(single.length + 1);
            } else {
                if (typeof setState1 === 'function') setState1(single.length)
            }
        }
    }, [single, type, sel, category, hasSecondImage])
    const counter = useRef(0);
    useEffect(()=>{
        if(!loading){
            counter.current = 0;
        }
    }, [loading])
    const imageLoaded = () => {
        counter.current += 1;
        let L = 0;
        console.log("called this : ", counter.current)
        if(imgState <= 0){
            if(!checkCategory(category)){
                if(category === "shirt"){
                    // L = 4;
                    L = sel["fabric"]["Shirt"].src.length + 2 
                } else if(category === "pant"){
                    L = 3 
                } else if(category === "formal") {
                    //// formal
                    L = 1 + sel["fabric"]["Shirt"].src.length + 1 + 1
                } else if(category === "blazer"){ 
                    L = 4 ;
                }
                else if(category === "sadri"){
                    L = 6
                }
                // console.log("this is happening")
            }
            else if(category === "suit"){
                L = 4;

                if(sel && sel.types && sel.types.includes("Vest")){
                    L = L + 1;    
                }
    
                if(jodh){
                    L = L-1;
                }
            } 
            else if(category === "kurta"){
                
                if (kurtaLayers && kurtaLayers.length > 0 && imgState <= 0) {
                    L = kurtaLayers.length;
                    if ((sel?.types.includes("Coat") || sel?.types.includes("Sadri"))) {
                        L += 1;
                    }
                }
                else if(imgState === -1){
                    if(initial){
                        L = 5;
                    } else {
                        L = 2;
                    }
                    
                } else {
                    L = 7;
                }
                
            }
            
            // L = sel.types.length
        }else{
            const offset = hasSecondImage ? 1 : 0;
            if( sel.types.includes("Coat") && category === "kurta" && imgState === (4 + offset)){
                L = 2;
                console.log("cuz of 1")
            } else if(sel?.types?.includes("Sadri") && category === "kurta" && imgState === (3 + offset)){
                L = 2;
                console.log("cuz of 2")
            } else if(category === "kurta" && imgState === (2 + offset) && !(sel.types.includes("Coat") || sel.types.includes("Kurta")) ){
                L = 2;
                console.log("cuz of 3")
            } else {
                L = 1;
            }
        }
        
        if ( (counter.current >= L && (category != "shirt" && category != "formal" && category !="kurta" && category != "sadri") )
            ||( ((category === "shirt" || category === "formal") && Array.isArray(sel.fabric["Shirt"].src)) && counter.current >= L )
            || (((category === "kurta") && Array.isArray(sel.fabric["Kurta"].src)) && counter.current >= L )
            || (((category === "sadri") && Array.isArray(sel.fabric["Sadri"].src)) && counter.current >= L )
            
        ) {
            setLoading(false);
            counter.current = 0;
            console.log("Setting it false")
        }
    }

    useEffect(()=>{
            if(loading){
                setTimeout(()=>{
                    setLoading(false);
                    console.log("setting because of timeout")
                    counter.current = 0;
                }, 5000)
            }
        }, [loading])

    return ( 
        <div className="v-d-body" id="display_image"
            style={{
                overflow: category === 'kurta' ? 'visible' : undefined,
                paddingBottom: category === 'kurta' ? '100px' : undefined
            }}

            onClick={()=>{
                if(!isMobile){
                    setMagnify(!magnify)
                }
                
            }}

            onMouseLeave={()=>{
                setMagnify(0)
            }}

            onMouseMove={(e)=>{
                
                const element = document.getElementById("display_image")
                
                var rect = element.getBoundingClientRect();
                

                
                var x = e.pageX - rect.left; //x position within the element.
                var y = e.pageY - rect.top;
                const pX = ((x)/rect.width)*100
                const pY=  ((y)/rect.height)*100
                // // console.log(rect)
                // // console.log("X:", x, "Y:", y, "max:", e.pageX, e.pageY)

                const left = Math.round(((-3)*(pX) / 5) + 30)
                const top = Math.round((100 - 2*pY))
                
                // // console.log(left, top)
                setXY([left, top])

                }}
            
            
        >

            {isMobile && <div style={{"position":"absolute", "zIndex":"100"}}>
                <Tooltip TransitionComponent={Zoom} title="Visible Images are Renderd. It May be different from actual product. Open Fabric info to see real images of Fabric ">
                    {/* <Button>Zoom</Button> */}
                    <img src={War} style={{"width":"20px", "opacity":"1"}}/>
                </Tooltip>
            </div>}
                    

            {/* https://stackoverflow.com/questions/56902522/react-show-loading-spinner-while-images-load */}
            {(loading) && (<div className='f-loading' 
                style={{background:"#E5E5E5"}}  
            >
                {/* <div>
                <img src={logo} style={{"width":"40px", "position":"absolute"}} /> */}
                <img alt src={aim} onerror="this.src='https://d1fufvy4xao6k9.cloudfront.net/images/garment/loading.gif'"/>
                {/* </div> */}
            </div>)}
            {sel && sel.types && imgState < 0 ? (

                <>
                    { category === "kurta" && kurtaLayers.length > 0 ? (
                        kurtaLayers.map((layer, idx) => {
                            const isCustom = !!sel?.modelSrc;
                            return (
                            <img key={idx} src={layer.src} className="v-display-img-kurta"
                                onLoad={imageLoaded}
                                style={
                                    magnify ? {...magnifyStyle(x, y), zIndex: layer.z} : {
                                        zIndex: layer.z,
                                        position: 'absolute',
                                        top: '0', 
                                        left: '0',
                                        width: '100%',
                                        height: '100%',
                                        maxHeight: 'none',
                                        transform: 'none',
                                        transformOrigin: 'top center',
                                        objectFit: 'contain'
                                    }
                                }
                            />
                        )})
                    ) : (
                    <img src={def_body} className={
                        `hori_center v-display-img-full dummy first_img_mob
                            ${    (category === 'shirt' || category === "blazer" || category === "sadri") ? `v-display-img-${category}`
                                : category === 'pant' ? 'v-display-img-pant'
                                : `v-display-img-${category}`}
                        `
                    }
                        onLoad={imageLoaded}
                        style={
                            magnify ? magnifyStyle(x, y) : {}
                        }
                    />
                    )}
                    
                    { category !="kurta" && <img src={def_shirt} className=
                        {`hori_center v-display-img-full first_img_mob dummy
                            ${isMobile ? 'mobile-image1' : ''} 
                            ${jodh ? `jodh_shirt`:''} 
                            ${    (category === 'shirt' || category === "blazer" || category === "sadri") ? `v-display-img-${category} def_pant`
                                : category === 'pant' ? 'v-display-img-pant'
                                : category === 'formal' ? 'v-display-default'
                                : category === "kurta" ? 'display_none' 
                                : '' }
                        `}
                        onLoad={imageLoaded}
                        style={
                            // imgState > 0 || sel.types.includes("Shirt") ?{"display":"none"}:
                            magnify ? magnifyStyle(x, y) : {} 
                        }
                    />}
                    { category === "blazer" && 
                        <img src={"https://firebasestorage.googleapis.com/v0/b/maviinvi.appspot.com/o/Suits%2FPant%2FPANT-1726940263526?alt=media&token=080a27a0-2fa6-4428-a573-280768af3313"} className={
                            `hori_center v-display-img-full dummy first_img_mob
                                v-display-img-blazer`
                        }
                            onLoad={imageLoaded}
                            style={
                                magnify ? magnifyStyle(x, y) : {}
                            }
                        />
                    }
            
                    {sel.types.map((val, key)=>{
                        if (category === "kurta" && ["Kurta", "Pajama", "Sadri", "Coat", "Vest"].includes(val)) return null;
                        const isKurtaAccessory = category === "kurta";
                        const kurtaStyle = isKurtaAccessory ? {
                            // transform: "translateX(-50%) scale(1.15)",
                            // transformOrigin: "top center",
                            top: 0,
                            position: "absolute",
                            left: 0,
                            width: "100%",
                            height: "100%"
                        } : {};

                        return(
                            <> { imgState < 0 && Object.hasOwn(sel.fabric[val], "default") ? (
                                <>
                                {sel.fabric[val].default && sel.fabric[val]["default"].map((value_img)=>{
                                    if (category === "kurta" && val === "Kurta") return null;
                                    return(
                                        <img src={ value_img }
                                            onLoad={imageLoaded}
                                            style={ magnify ? {...magnifyStyle(x, y), ...{"zIndex":50-sel.fabric[val]["pos"]}, ...kurtaStyle} : 
                                                {"zIndex":50-sel.fabric[val]["pos"], ...kurtaStyle} } 
                                            className=
                                            {`v-display-img-full first_img_mob ${isKurtaAccessory ? 'hori_center_no_transform' : 'hori_center'} this_is_def
                                                ${isMobile ? 'mobile-image2' : ''}
                                                ${   (category === 'shirt' || category === "blazer" || category === "sadri") ? `v-display-img-${category}`
                                                    :category === 'pant' ? 'v-display-img-pant'
                                                    :`v-display-img-${category}`}
                                            `}
                                        />
                                    )
                                })}
                            </>
                                )
                                : ( ((imgState === 0 && !( category === "kurta" &&  (val === "Coat" || val === "Sadri" || val === "Kurta")) ) || (imgState === -1)) && <>
                                
                                    { sel && sel.fabric && Object.hasOwn(sel.fabric, val) && Array.isArray( sel.fabric[val]["src"] ) ? 
                                            <>
                                                { sel.fabric[val]["src"].map((values, keys)=>{
                                                    return(
                                                        <img src={ values }
                                                        onLoad={imageLoaded}
                                                        style={ magnify ? {...magnifyStyle(x, y), ...{"zIndex":50-sel.fabric[val]["pos"]}, ...kurtaStyle} : 
                                                            {"zIndex":50-sel.fabric[val]["pos"], ...kurtaStyle} } 
                                                        className=
                                                        {`v-display-img-full first_img_mob ${isKurtaAccessory ? 'hori_center_no_transform' : 'hori_center'} 
                                                            ${isMobile ? 'mobile-image2' : ''}
                                                            ${(category === 'shirt' || category === "blazer" || category === "sadri") ? `v-display-img-${category}`
                                                                :category === 'pant' ? 'v-display-img-pant'
                                                                :`v-display-img-${category}`}
                                                        `}
                                                        />
                                                    )
                                                }) }
                                            </>
                                    : 
                                        <img src={ sel && sel.fabric && Object.hasOwn(sel.fabric, val) ? sel.fabric[val]["src"] : "this" }
                                        onLoad={imageLoaded}
                                        style={ magnify ? {...magnifyStyle(x, y), ...{"zIndex":50-sel.fabric[val]["pos"]}, ...kurtaStyle} : 
                                            {"zIndex":50-sel.fabric[val]["pos"], ...kurtaStyle} } 
                                        className=
                                        {`v-display-img-full first_img_mob ${isKurtaAccessory ? 'hori_center_no_transform' : 'hori_center'} 
                                            ${isMobile ? 'mobile-image2' : ''}
                                            ${(category === 'shirt' || category === "blazer" || category === "sadri")? `v-display-img-${category}`
                                                :category === 'pant' ? 'v-display-img-pant'
                                                :`v-display-img-${category}`}
                                            ${imgState ===0 && category === "kurta" && (val === "Coat" || val === "Sadri")?'display_none':''}
                                        `}
                                        />
                                    }
                                </>)
                                }
                            </>
                            
                        )
                    })}
                    {
                    ((category === "kurta" && (sel?.types.includes("Coat") || sel?.types.includes("Sadri")))) && null}
                </>
                
                
            )
            : sel && sel.types && imgState === 0 ?  (

                <>
                    { category === "kurta" && kurtaLayers.length > 0 ? (
                        kurtaLayers.map((layer, idx) => {
                            const isCustom = !!sel?.modelSrc;
                            return (
                            <img key={idx} src={layer.src} className={`v-display-img-full first_img_mob v-display-img-kurta hori_center_no_transform`}
                                onLoad={imageLoaded}
                                style={
                                    magnify ? {...magnifyStyle(x, y), zIndex: layer.z} : {
                                        zIndex: layer.z,
                                        position: 'absolute',
                                        top: '0', 
                                        left: '0',
                                        width: '100%',
                                        height: '100%',
                                        maxHeight: 'none',
                                        transform: 'none',
                                        transformOrigin: 'top center'
                                    }
                                }
                            />
                        )})
                    ) : (
                    <img src={def_body} className={
                        `hori_center v-display-img-full dummy first_img_mob
                            ${    (category === 'shirt' || category === "blazer" || category === "sadri") ? `v-display-img-${category}`
                                : category === 'pant' ? 'v-display-img-pant'
                                :`v-display-img-${category}`}
                        `
                    }
                        onLoad={imageLoaded}
                        style={
                            magnify ? magnifyStyle(x, y) : {}
                        }
                    />
                    )}
                    {
                     (category === "sadri") && <img src={hands} className={
                        `hori_center v-display-img-full dummy first_img_mob hands
                            ${    (category === 'shirt' || category === "blazer" || category === "sadri") ? `v-display-img-${category}`
                                : category === 'pant' ? 'v-display-img-pant'
                                :`v-display-img-${category}`}
                        `
                    }
                        onLoad={imageLoaded}
                        style={
                            magnify ? magnifyStyle(x, y) : {}
                        }
                    />}
                    
                    { ((category !="kurta" && (category === "suit" && !sel.types.includes("Shirt")) ) || category === "blazer" || category === "shirt") && <img src={def_shirt} className=
                        {`hori_center v-display-img-full first_img_mob dummy
                            ${isMobile ? 'mobile-image1' : ''} 
                            ${jodh ? `jodh_shirt`:''} 
                            ${    (category === 'shirt' || category === "blazer" || category === "sadri") ? `v-display-img-${category} def_${category}`
                                : category === 'pant' ? 'v-display-img-pant'
                                : category === 'formal' ? 'v-display-default'
                                : category === "kurta" ? 'display_none' 
                                : `v-display-img-${category}` }
                            
                            
                        `}
                        onLoad={imageLoaded}
                        style={
                            // imgState > 0 || sel.types.includes("Shirt") ?{"display":"none"}:
                            magnify ? magnifyStyle(x, y) : {} 
                        }
                    />}
                    { category === "blazer" && 
                        <img src={"https://firebasestorage.googleapis.com/v0/b/maviinvi.appspot.com/o/Suits%2FPant%2FPANT-1726940263526?alt=media&token=080a27a0-2fa6-4428-a573-280768af3313"} className={
                            `hori_center v-display-img-full first_img_mob
                                v-display-img-blazer def_pant`
                        }
                            onLoad={imageLoaded}
                            style={
                                magnify ? magnifyStyle(x, y) : {}
                            }
                        />
                    }
            
                    {sel.types.map((val, key)=>{
                        if (category === "kurta") return null;
                        const isKurtaAccessory = category === "kurta";
                        const kurtaStyle = isKurtaAccessory ? {
                            transform: "translateX(-50%) scale(1.15)",
                            transformOrigin: "top center",
                            top: 0,
                            position: "absolute",
                            left: "50%"
                        } : {};
                        return(
                            <> { imgState < 0 && Object.hasOwn(sel.fabric[val], "default") ? (

                                    <>
                                        {sel.fabric[val]["default"].map((value_img)=>{
                                            return(
                                                <img src={ value_img }
                                                    onLoad={imageLoaded}
                                                    style={ magnify ? {...magnifyStyle(x, y), ...{"zIndex":50-sel.fabric[val]["pos"]}} : 
                                                        {"zIndex":50-sel.fabric[val]["pos"]} } 

                                                    className=
                                                    {`v-display-img-full first_img_mob hori_center this_is_def
                                                        ${isMobile ? 'mobile-image2' : ''}
                                                        ${   (category === 'shirt' || category === "blazer" || category === "sadri") ? `v-display-img-${category}`
                                                            :category === 'pant' ? 'v-display-img-pant'
                                                            :`v-display-img-${category}`}
                                                    `}
                                                />
                                            )
                                        })}
                                    </>
                                    
                                )
                                : ( ((imgState === 0 && !( category === "kurta" &&  (val === "Coat" || val === "Sadri")) ) || (imgState === -1)) && <>
                                
                                    { sel && sel.fabric && Object.hasOwn(sel.fabric, val) && Array.isArray( sel.fabric[val]["src"] ) ? 
                                            <>
                                                { sel.fabric[val]["src"].map((values, keys)=>{
                                                    return(
                                                        <>
                                                        <img src={ values }
                                                        onLoad={imageLoaded}
                                                        style={ magnify ? {...magnifyStyle(x, y), ...{"zIndex":50-sel.fabric[val]["pos"]}, ...kurtaStyle} : 
                                                            {"zIndex":50-sel.fabric[val]["pos"], ...kurtaStyle} } 

                                                        className=
                                                        {`v-display-img-full first_img_mob ${isKurtaAccessory ? 'hori_center_no_transform' : 'hori_center'} 
                                                            ${isMobile ? 'mobile-image2' : ''}
                                                            ${(category === 'shirt' || category === "blazer" || category === "sadri") ? `v-display-img-${category}`
                                                                :category === 'pant' ? 'v-display-img-pant'
                                                                :`v-display-img-${category}`}
                                                            ${imgState ===0 && category === "kurta" && (val === "Coat" || val === "Sadri")?'display_none':''}
                                                        `}
                                                        />
                                                        {category === "kurta" && val === "Kurta" && keys ===0 && 
                                                          <img src={ kurta_hand_k }
                                                          onLoad={imageLoaded}
                                                          style={ magnify ? {...magnifyStyle(x, y), ...{"zIndex":50-sel.fabric[val]["pos"]}} : 
                                                              {"zIndex":50-sel.fabric[val]["pos"]} } 
  
                                                          className=
                                                          {`v-display-img-full first_img_mob hori_center 
                                                              ${isMobile ? 'mobile-image2' : ''}
                                                              ${(category === 'shirt' || category === "blazer" || category === "sadri") ? `v-display-img-${category}`
                                                                  :category === 'pant' ? 'v-display-img-pant'
                                                                  :`v-display-img-${category}`}
                                                              ${imgState ===0 && category === "kurta" && (val === "Coat" || val === "Sadri")?'display_none':''}
                                                              ${imgState ===0 && category === "suit" && (val === "Shirt" && sel.style && sel.style.Coat && sel.style.Coat.F[0][0] === "J" )?'display_none':''}
                                                          `}
                                                          />  

                                                        }
                                                        </>
                                                    )
                                                }) }
                                            </>
                                    : 
                                        <img src={ sel && sel.fabric && Object.hasOwn(sel.fabric, val) ? sel.fabric[val]["src"] : "this" }
                                        onLoad={imageLoaded}
                                        style={ magnify ? {...magnifyStyle(x, y), ...{"zIndex":50-sel.fabric[val]["pos"]}, ...kurtaStyle} : 
                                            {"zIndex":50-sel.fabric[val]["pos"], ...kurtaStyle} } 

                                        className=
                                        {`v-display-img-full first_img_mob ${isKurtaAccessory ? 'hori_center_no_transform' : 'hori_center'} 
                                            ${isMobile ? 'mobile-image2' : ''}
                                            ${(category === 'shirt' || category === "blazer" || category === "sadri")? `v-display-img-${category}`
                                                :category === 'pant' ? 'v-display-img-pant'
                                                :`v-display-img-${category}`}
                                            ${imgState ===0 && category === "kurta" && (val === "Coat" || val === "Sadri")?'display_none':''}
                                        `}
                                        // ${imgState ===0 && category === "suit" && (val === "Shirt" && sel.style && sel.style.Coat && sel.style.Coat.F[0][0] === "J" )?'display_none':''}
                                        />
                                    }
                                </>)
                                }
                            </>
                            
                        )
                    })}
                </>
                
                
            )
            : imgState > 0 ?
            (<>

            {/* 1. Coat
            2. vest
            3. Pant
            4. Shirt */}
            
                {/* <img src={s2} className='v-display-img-full' onLoad={imageLoaded}/>
                <img src={s5} className='v-display-img-full' onLoad={imageLoaded}/>
                <img src={s3} className='v-display-img-full' onLoad={imageLoaded}/>
                <img src={s1} className='v-display-img-full' onLoad={imageLoaded}/> */}
                {/* {type && type === 0 ? (<>
                
                </>)
                : (<></>)
                } */}
                { hasSecondImage && imgState === 1 ? (
                    secondLayers.map((layer, idx) => (
                        <img key={idx} src={layer.src} className={`v-display-img-full hori_center ${isMobile ? 'mobile-image' : ''} 
                                ${isMobile ? "kurta_mob_scale" : ""}
                            `}
                            onLoad={imageLoaded}
                            style = {magnify ? {...magnifyStyle(x, y), zIndex: layer.z} : {zIndex: layer.z}}
                        />
                    ))
                ) :
                type === 0 && single && (hasSecondImage ? single[imgState-2] : single[imgState-1]) && ((hasSecondImage ? single[imgState-2]["typ"] : single[imgState-1]["typ"]) === 0) ? (
                    <img src={(hasSecondImage ? single[imgState-2]["src"] : single[imgState-1]["src"])} className={`v-display-img-full hori_center ${isMobile ? 'mobile-image' : ''} 
                            ${isMobile && (  (category === "formal" && imgState === 1) || (category === "suit" && imgState ===3)) ? "shirt_mob_scale" : ""}
                            ${isMobile && (category === "kurta" && imgState === (hasSecondImage ? 2 : 1) ) ? "kurta_mob_scale" : ""}
                            ${isMobile && (category === "kurta" && sel?.types.includes("Sadri") && imgState === (hasSecondImage ? 4 : 3) ) ? 'sadri_mob_scale' : ''}
                            ${isMobile && 
                                ((category === "kurta" && sel?.types.includes("Sadri") && imgState === (hasSecondImage ? 3 : 2) ) || (category === "kurta" && sel?.types.includes("Coat") && imgState === (hasSecondImage ? 5 : 4)) ) ? 'pajama_mob_scale' : ''}
                            ${isMobile && (category === "kurta" && !sel?.types.includes("Sadri") && !sel?.types.includes("Coat") && imgState === (hasSecondImage ? 3 : 2) ) ? 'pajama_mob_scale' : ''}
                        `}
                            
                        onLoad={imageLoaded}

                        style = {magnify ? magnifyStyle(x, y):{}}
                    />
                ) : (<>
                    {type===0 && single && (hasSecondImage ? single[imgState-2] : single[imgState-1]) && (hasSecondImage ? single[imgState-2]["src"] : single[imgState-1]["src"]).map((imgV, imgKey)=>{
                        return(
                            <img src={imgV} className={`v-display-img-full hori_center ${isMobile ? 'mobile-image' : ''} 
                            ${(  (category === "formal" && imgState === 1) || (category === "suit" && imgState ===3) || (category === "shirt" && imgState === 1) ) ? "shirt_mob_scale" : ""}
                            ${isMobile && (category === "kurta" && imgState === (hasSecondImage ? 2 : 1) ) ? "kurta_mob_scale" : ""}
                            ${isMobile && (category === "kurta" && sel?.types.includes("Sadri") && imgState === (hasSecondImage ? 4 : 3) ) ? 'sadri_mob_scale' : ''}
                            ${isMobile && 
                                ((category === "kurta" && sel?.types.includes("Sadri") && imgState === (hasSecondImage ? 3 : 2) ) || (category === "kurta" && sel?.types.includes("Coat") && imgState === (hasSecondImage ? 5 : 4)) ) ? 'pajama_mob_scale' : ''}
                            ${isMobile && (category === "kurta" && !sel?.types.includes("Sadri") && !sel?.types.includes("Coat") && imgState === (hasSecondImage ? 3 : 2) ) ? 'pajama_mob_scale' : ''}
                        `}
                                onLoad={imageLoaded}

                                style = {magnify ? magnifyStyle(x, y):{}}
                            />

                            
                        )
                    })

                    }
                </>)

                }

                {type && type === 1 ? (<>
                    {Single && Single[imgState-1]["typ"] === 0 ? (
                    <img src={Single[imgState-1]["src"]} className={`v-display-img-full ${isMobile ? 'mobile-image' : ''} 
                            ${isMobile && (  (category === "formal" && imgState === 1) || (category === "suit" && imgState ===3)) ? "shirt_mob_scale" : ""}
                            ${isMobile && (category === "kurta" && imgState === 1 ) ? "kurta_mob_scale" : ""}
                            ${isMobile && (category === "kurta" && sel?.types.includes("Sadri") && imgState === 3 ) ? 'sadri_mob_scale' : ''}
                            ${isMobile && 
                                ((category === "kurta" && sel?.types.includes("Sadri") && imgState === 2 ) || (category === "kurta" && sel?.types.includes("Coat") && imgState === 4) ) ? 'pajama_mob_scale' : ''}
                            ${isMobile && (category === "kurta" && !sel?.types.includes("Sadri") && !sel?.types.includes("Coat") && imgState === 2 ) ? 'pajama_mob_scale' : ''}

                        `}
                        style={loading ? {"display":"none"} : {} }
                        onLoad={imageLoaded}
                    />
                ) : (<>
                    {type === 1 && Single && Single[imgState-1]["src"].map((imgV, imgKey)=>{
                        return(
                            <img src={imgV} className={`v-display-img-full ${isMobile ? 'mobile-image' : ''}
                            ${isMobile && (  (category === "formal" && imgState === 1) || (category === "suit" && imgState ===3)) ? "shirt_mob_scale" : ""}
                            ${isMobile && (category === "kurta" && imgState === 1 ) ? "kurta_mob_scale" : ""}
                            ${isMobile && (category === "kurta" && sel?.types.includes("Sadri") && imgState === 3 ) ? 'sadri_mob_scale' : ''}
                            ${isMobile && 
                                ((category === "kurta" && sel?.types.includes("Sadri") && imgState === 2 ) || (category === "kurta" && sel?.types.includes("Coat") && imgState === 4) ) ? 'pajama_mob_scale' : ''}
                            ${isMobile && (category === "kurta" && !sel?.types.includes("Sadri") && !sel?.types.includes("Coat") && imgState === 2 ) ? 'pajama_mob_scale' : ''}
                        `}
                                style={loading ? {"display":"none"} : {} }
                                onLoad={imageLoaded}
                            />
                        )
                    })

                    }
                </>)
                }
                </>)
                : (<></>)
                }
                
                
            </>)
            : (<></>)
            
            }
            
            

        </div> 
    );
}

export default ViewImages;


///
// presets page not in center for phone

/// choose presets from admin panel to display on home page

// add now button on saved mesasuremenrts

// clone a cloth selected option

// content in websites

// cart item delete

// get help custom measurements , animation with good text in custom measuremnts

// video of explaore in home page not in center in phone

// collaborations not smooth in infinite

// scrolling a bit much on style svgs 
// collaborations not smooth in infinite

// scrolling a bit much on style svgs 
